<template>
  <div class="column">
    <h4 class="has-text-black is-size-5 has-text-weight-bold" v-if="edit">{{ title }}</h4>
    <div class="card has-background-white" v-if="!edit">
      <div class="card-content">
        <div class="media">
          <div class="media-left">
            <div class="company-top-logo is-flex is-justify-content-center is-align-items-center">
              <img v-if="logo" :src="logo" style="max-width:140px" />
              <div v-else class="is-size-6 has-text-weight-semibold has-text-black">
                {{ companyName }}
              </div>
            </div>
            <div class="company-qr is-flex is-justify-content-center is-align-items-center">
              <span class="has-text-weight-bold is-size-3">QR</span>
            </div>
            <div class="company-top-logo is-borderless is-flex is-justify-content-center is-align-items-center">
              <img
                src="../assets/Manufacton_Logo.png"
                width="140"
                height="40"
                class="is-centered display-table"
              >
            </div>
            <h5 class="is-size-5 has-text-weight-semibold has-text-black-bis has-text-centered">
                {{ getLabelType }}
            </h5>
          </div>
          <div class="media-content">
            <div class="column">
              <div class="columns">
                <div class="column pt-0 qr-top-label">
                  <div
                    class="is-size-3 has-text-black-bis line-height has-text-weight-semibold mb-2"
                    v-for="(obj, index) in labels"
                    v-show="obj.value !== 'hide'"
                    :key="index"
                  >{{ get(obj, 'label', '') }}</div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-size-3 has-text-grey-dark line-height has-text-weight-semibold">
                    <p v-if="type === 'item'">Item QTY:</p>
                    <p v-else-if="type === 'shipping' || type === 'partial'">Total # Items:</p>
                    <p v-else-if="type === 'serial'">Item QTY:</p>
                    <p v-else-if="type === 'material'">Total # Materials:</p>
                    <div v-else-if="type === 'materialItems'" class="is-flex is-justify-content-space-between is-align-items-center">
                      <span class="line-height">Materials QTY:</span>
                      <span class="line-height">Measure/Unit:</span>
                    </div>
                    <p class="line-height" v-else>QTY:</p>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="card has-background-white border-radius" v-else>
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <div class="company-top-logo is-flex is-justify-content-center is-align-items-center">
                  <img v-if="logo" :src="logo" style="max-width:140px">
                  <img src="../assets/140x40.jpg" v-else>
                </div>
                <div class="company-qr is-flex is-justify-content-center is-align-items-center">
                  <span class="has-text-weight-bold is-size-3">QR</span>
                </div>
                <div class="company-top-logo is-borderless is-flex is-justify-content-center is-align-items-center">
                  <img
                    src="../assets/Manufacton_Logo.png"
                    width="140"
                    height="40"
                    class="is-centered display-table"
                  >
                </div>
                 <h5 class="is-size-5 has-text-weight-semibold has-text-black-bis has-text-centered mb-3">
                    {{ getLabelType }}
                  </h5>
              </div>
              <div class="media-content">
                <div class="columns">
                  <div class="column qr-top-label mb-2">
                    <div v-for="(obj, index) in labels" :key="index">
                      <VueMultiselect
                        :model-value="labels[index]"
                        :options="sortedOptions"
                        label="label"
                        track-by="value"
                        placeholder="Select a label"
                        :show-labels="false"
                        :allow-empty="false"
                        @update:modelValue="onLabelUpdate(index, $event)"
                        @open="$emit('dropdown:active', true)"
                        @close="$emit('dropdown:active', false)"
                      />
                    </div>
                  </div>
                  <div class="column is-narrow">
                    <a class="button is-black" @click="setDefault">Restore Default</a>
                  </div>
                </div>
                  <div class="columns">
                    <div class="column is-size-3 has-text-grey-dark line-height has-text-weight-semibold">
                      <p v-if="type === 'item'">Item QTY:</p>
                      <p v-else-if="type === 'shipping' || type === 'partial'">Total # Items:</p>
                      <p v-else-if="type === 'serial'">Item QTY:</p>
                      <p v-else-if="type === 'material'">Total # Materials:</p>
                      <div v-else-if="type === 'materialItems'"  class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Materials QTY:</span>
                        <span>Measure/Unit:</span>
                      </div>
                      <p v-else>QTY:</p>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import VueMultiselect from 'vue-multiselect';
import { sortBy, get } from 'lodash';

export default defineComponent({
  name: 'QrSample',
  components: { VueMultiselect },
  props: {
    type: { type: String, default: '' },
    title: { type: String, default: '' },
    labels: { type: Array, default: () => [] },
    edit: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    logo: { type: String, default: '' },
    companyName: { type: String, default: '' },
  },
  emits: ['setDefault', 'removeLogo', 'update:labels'],
  setup(props, { emit }) {
    const getLabelType = computed(() => {
      switch (props.type) {
        case 'shipping': return 'Production Order';
        case 'item': return 'Production Item';
        case 'material': return 'Material Order';
        case 'materialItems': return 'Material Item';
        case 'partial': return 'Shipping Order';
        case 'serial': return 'Shipping Order Item';
        case 'delivery': return 'Shipping Delivery';
        case 'inventoryItem': return 'Inventory Item';
        default: return 'Production Order';
      }
    });

    const sortedOptions = computed(() => sortBy(props.options, 'label'));

    const setDefault = () => {
      emit('setDefault', props.type);
    }

    const removeLogo = () => {
      emit('removeLogo');
    }

    const onLabelUpdate = (index, value) => {
      const updated = [...props.labels];
      updated[index] = value;
      emit('update:labels', updated);
    }

    return {
      getLabelType,
      sortedOptions,
      setDefault,
      removeLogo,
      onLabelUpdate,
      get,
    };
  },
});
</script>

<style scoped>
</style>
